import React, { Component } from 'react';
import FormClient from '../../sales/FormClient';
import FormSale from '../../sales/FormSale';

import { isEmpty, size } from 'lodash';
import PopUp from '../../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText from '../../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../../containers/Layout';
import { initClient, initSale } from '../../StockFormsStruct';
import ProductLineCell from '../../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../../commonModules/utils/statsFunctions';
import ConfirmFormTemplate from '../Forms/ConfirmFormTemplate';

const initErrors = {
    shop_id: "",
    nature:"",
    products:[
        {
            product_id:"",
            quantity:"",
            price_U_real:"",
            priceTotal:"",
        }
    ],
}

class FormTransfreInstallToSale extends Component {
    state = { 
        sale: Object.assign({}, initSale),
        client: Object.assign({}, initClient, this.props.client),
        errors: Object.assign({},initErrors),
        errorsClient: Object.assign({},initClient),
        view: "sale",
        numberProd: 1,
        sending: false,
        uniqueID: generateUniqueId(),
        form: <div></div>  // Liste des produits

    }
    componentDidMount = () => {
        const { sale, errors } = this.state;
        const { PRODUCTS } = this.props;
        
        let newSale = Object.assign({}, sale, this.props.install)
        newSale.nature = "payg"
        let cpProducts = newSale.products
        let cpErrors = Object.assign({}, errors)
        let errProds = []
        let nbProds = size(newSale.products)
        let total = 0;

        //Si produit deja preparer
        cpProducts.forEach( (prod, i) => {
            let option = {
                value: prod.product_id, 
                label: `${PRODUCTS[ prod.product_id ].marque} - ${PRODUCTS[ prod.product_id ].name}`
            }
            const max = this.findMax(option.value, newSale.shop_id)    
            cpProducts[i].product_id = option.value
            cpProducts[i].max = max.max
            cpProducts[i].stock_id = max.stock_id
            cpProducts[i].price = max.price
            cpProducts[i].price_U_real = max.price
            cpProducts[i].priceU = max.priceU
            cpProducts[i].prod_tva_rate = max.tva
            cpProducts[i].priceTotal = (max.price * (cpProducts[i].quantity || 0) )
            cpProducts[i].installQty = max.installQty
            cpProducts[i].display = option
            errProds.push({
                product_id:"",
                quantity:"",
                price_U_real:"",
                priceTotal:"",
            })

            total += parseFloat(cpProducts[i].priceTotal)
        })

        cpErrors.products = errProds
        newSale.products = cpProducts
        newSale.total = total
        this.setState({ 
            sale: newSale,
            errors: cpErrors,
            numberProd: nbProds, 
        }, () => {
            // Met à jour la liste produit
            console.log("[DEBUG], start mouting FormTransfreInstallToSale, ",this.state.numberProd)
            console.log("[DEBUG], start mouting FormTransfreInstallToSale, ",cpProducts)
            this.createAddForm()
        });
    }
    
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        } else if(name === "shop_id"){
            console.log("change shop_id");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                            price:"",
                            price_U_real:"",
                            priceTotal:"",
                        }
                    ],
                },
                numberProd:1
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            });
        }        
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop = this.state.sale.shop_id
        const max = this.findMax(value, shop)    

        let cpProducts = this.state.sale.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max.max
        cpProducts[index].stock_id = max.stock_id
        cpProducts[index].price = max.price
        cpProducts[index].price_U_real = max.price
        cpProducts[index].priceU = max.priceU
        cpProducts[index].prod_tva_rate = max.tva
        cpProducts[index].priceTotal = (max.price * (cpProducts[index].quantity || 0) )
        cpProducts[index].installQty = max.installQty
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:cpProducts,
            }
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });        
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE)=> { // return available stock and it's id
        const { PRODUCTS, install } = this.props
        let max = 0
        let stock_id = ""
        let price = 0
        let priceU = 0
        let tva = 0
        let installItem = install.products.find(prod => prod.product_id === product_id)
        let stock = Object.values(list).find(stock => stock.product_id === product_id  && stock.shop_id === shop_id ) || {quantity: 0}
        let installQty = 0

        if( !isEmpty(installItem) ){    // if available  = 0 but install > 0
            installQty = installItem.quantity 
            max = installQty
            // max = stock.quantity + installQty
            stock_id = ""
            price = PRODUCTS[installItem.product_id].prix_venteTTC
            tva = PRODUCTS[installItem.product_id].tva_rate || 0
            priceU = PRODUCTS[installItem.product_id].prix_venteHT

        } 
        // else if(!isEmpty(stock) ){ 
        //     max = stock.quantity
        //     stock_id = stock.id
        //     price = PRODUCTS[stock.product_id].prix_venteTTC
        //     tva = PRODUCTS[stock.product_id].tva_rate || 0
        //     priceU = PRODUCTS[stock.product_id].prix_venteHT
        // }
        return {
            max, 
            stock_id, 
            price, 
            priceU, 
            tva, 
            installQty
        }
    }

    createProductList = () => {
        const { sale } = this.state;
        const list = [{value:"", label:"Chosissez un Produit"}]
        const  { AVAILABLE, PRODUCTS } = this.props
        if(AVAILABLE){
            let selectedProds = sale.products.map( prod => prod.product_id)
            Object.values(AVAILABLE).map(stock => {   
                let selected = selectedProds.includes(stock.product_id)
                
                if(stock.shop_id === this.state.sale.shop_id && stock.quantity > 0){
                    list.push (       
                        {value:stock.product_id, 
                        label:`${PRODUCTS[ stock.product_id ].marque} - ${PRODUCTS[ stock.product_id ].name}`, 
                        disabled:true
                        // disabled:selected
                    })
                }
            })
        }
        return list
    }
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()
        console.log("[DEBUG], start mouting createAddForm, ",products.length)

        for (let i = 0; i < this.state.numberProd;i++) {
            let prod = this.state.sale.products[i]
            let background = ""
            // let installItem = {}
            // let installQty = 0
            if (prod.type === "install_item") {
                background = "lightblue"
                // installItem = this.props.install.products.find(prod => prod.product_id === product_id)
                // installQty = installItem.quantity
            }
            tab.push(
                <TableRow key={i} style={{ background }}>             
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={prod.display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        helperText={(prod.type === "install_item") &&  `Quantité prévue: ${prod.installQty}`}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={prod.max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={prod.quantity} 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={prod.max ? "Disponible : "+ prod.max :"" }
                        />
                    </TableCell>
                    <TableCell>
                        <InputText 
                            disabled
                            type="number" 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={prod.price} 
                            name={"prod_-price-"+i} 
                            title="Prix"
                            error={this.state.errors.products[i].price}
                            helperText={prod.price_U_real ? "Prix Unitaire Base: "+ prod.price_U_real :"" }
                        />
                    </TableCell>
                    <TableCell >
                        <InputText 
                            type="number" 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={prod.priceTotal } 
                            name={"prod_-priceTotal-"+i} 
                            placeholder="Prix Total"
                            error={this.state.errors.products[i].priceTotal}
                            helperText={(prod.price_U_real && prod.quantity) ? "Prix Total Base : "+ 
                            (prod.price_U_real * (prod.quantity) ):"" }
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }
        console.log("[DEBUG], start mouting createAddForm, tab,",tab.length)

        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        console.log("Form Installation ,handleAddProd,")
        toast.error("NOT AVAILABLE FOR THIS OPTION")
        return
        const shop_id = this.state.sale.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    price:"",
                    price_U_real:"",
                    priceTotal:"",
                    priceU:"",
                    prod_tva_rate: "",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                    price_U_real:"",
                    priceTotal:"",
                }]
            },
            numberProd:this.state.numberProd+1,
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });  
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Installation ,handleAddProdByCSV,",productList)
        toast.error("NOT AVAILABLE FOR THIS OPTION")
        return
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.sale.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        var total = 0 
        let discount = 0;
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Sales ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = this.findMax(value[5].id, shop_id)    
            if (max.stock_id ===""){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            nbOfProduct++

            const price = (value[3] / value[2]).toFixed(2) || max.price
            const priceU = (max.price / ( 1 + max.tva / 100)).toFixed(2)

            const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: max.max,
                stock_id: max.stock_id,
                price: price,
                priceUReal: max.price,
                priceU: priceU, 
                priceTotal: value[3],
                //priceHT: "",
                prod_tva_rate: max.tva,
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
                priceUReal:"",
                priceTotal:"",
                
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
            total += parseFloat(value[3])
            let addDiscount = ((max.priceU * value[2] ) - value[3]).toFixed(2)
            discount += addDiscount > 0 ? addDiscount : 0
         
        })
        console.log("Form Sales ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Sales ,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    products:[
                        ...productListLocal],
                    total,
                    discount
                },
                errors:{
                    ...this.state.errors,
                    products:[
                        ...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.sale.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        cpProducts.map( prod => {
            if ( prod.price_U_real && prod.quantity && prod.priceTotal){
                total += parseFloat(prod.priceTotal)
            }
        }) 
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products: cpProducts,
                total
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
            
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });    
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.sale.products)
            cpProducts[index][name] = value
            if(name === "quantity" || name === "price" || name === "priceTotal") {   
                if(value ==="" || regex.test(value)){// update value only if its a int
                    let discount = 0;
                    let total = 0;
                    cpProducts.map( prod => {
                        if ( prod.price_U_real && prod.quantity && prod.priceTotal){

                            let addDiscount = (prod.price_U_real * prod.quantity ) - prod.priceTotal
                            discount += addDiscount > 0 ? addDiscount : 0
                            total += parseFloat(prod.priceTotal)
                        }
                    })               
                    cpProducts[index].price = Math.round(cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].price_U_real
                    cpProducts[index].priceU = Math.round(cpProducts[index].price / ( 1 + cpProducts[index].prod_tva_rate / 100))

                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            discount,
                            total
                        }
                    }, () => {
                        // Met à jour la liste produit
                        this.createAddForm()
                    }); 
                }
                
            } else {
                this.setState({
                    ...this.state,
                    sale:{
                        ...this.state.sale,
                        products:cpProducts,
                    }
                }, () => {
                    // Met à jour la liste produit
                    this.createAddForm()
                }); 
            }
                    
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [field]:value
                }
            }, () => {
                // Met à jour la liste produit
                this.createAddForm()
            }); 
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        const required = Object.keys(errors)
        if (this.state.sale.sale_credit){
            required.push("comments") // comment is required only if sale credit
        }

        const requiredProdItem = [ "product_id", "quantity", "price_U_real", "priceTotal"]
        // if(this.state.sale.nature !== "payg"){
        //     notRequired.push("cli_type", "cli_typeDisplay")
        // }

        const sale = Object.assign({}, this.state.sale)
        required.map( field => {
            console.log(field);
            if( isEmpty(sale[field]) ) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                sale.products.map((item, j) => {
                    requiredProdItem.map( field2 => { // field2 product_id || quantity
                        
                        if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })
            } else {// not empty
                errors[field] = ""   
            }
        })
                
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        }, () => {
            // Met à jour la liste produit
            this.createAddForm()
        });
        if(noErrors){
            this.setState({
                view: "confirm"
                // view : "client"
            })
        } else {// !VALIDATE
            toast.error(  "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }

    handleChangeClient =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                [field]:value,
            }
        })
    }
    handleSubmit = async () => {
        let sale = Object.assign({}, this.state.sale)
        sale.date = new Date()
        sale.discount = parseFloat(sale.discount) 
        sale.total_price = parseFloat(sale.total)
        sale.unique_id = this.state.uniqueID
        for (let i = 0; i < sale.products.length; i++){
            sale.products[i].quantity = parseInt(sale.products[i].quantity)                      
            sale.products[i].price = parseFloat(sale.products[i].priceTotal)     
        }
            
        await this.props.createSaleFromInstall(sale)
        
        if(this.props.STATE.sales.error){
            console.log("ERROR", this.props.STATE.sales.error);
            toast.error( this.props.STATE.sales.error)
        } else {
            //success 
            toast.info("Opération enregistrée avec succès")
            this.clearForms()                        
            this.props.handleClose()
        }                
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            sale: Object.assign({}, initSale),
            client: Object.assign({}, initClient),
            // errors?
            errors: Object.assign({}, initErrors),
            errorsClient: Object.assign({}, initClient),                
        })
    }

    render() {
        const { view, sale, client, errors } = this.state;
        console.log("[STATE] NEW INSTALL FORM ", sale);
        console.log("[STATE] NEW errors FORM ", errors);
        console.log("[DEBUD] NEW errors FORM ", this.state.form);
        // console.log("[PROPS] NEW SALE FORM ",this.props);

        const fieldList = [
            {name: "client_lastname", label:"Nom", display: client.client_lastname},
            {name: "client_firstname", label:"Prénom", display: client.client_firstname},
            {name: "client_address", label:"Adresse", display: client.client_address},
            {name: "client_city", label:"Ville", display: client.client_city},
            {name: "client_country", label:"Pays", display: client.client_country},
            {name: "client_tel", label:"Téléphone", display: client.client_tel},
            {name: "client_email", label:"Email", display: client.client_email},
            {name: "shop_id", label:"Magasin", display: sale.shop_id && this.props.SHOPS[sale.shop_id].name},
            {name: "nature", label:"Nature", display:  sale.natureDisplay.label},
            {name: "sale_credit", label: "Vente à Crédit", display: (sale.sale_credit ? "Oui" : "Non") },
            {name: "transport", label:"Coût Transport", display: sale.transport},
            {name: "taxes", label:"Autres Taxes", display: sale.taxes},        
            {name: "products"},   
            {name: "comments", label:"Commentaires",display: sale.comments},
            {name: "discount", label:"Réduction Totale", display: sale.discount},
            {name: "total", label:"Montant Total", display: sale.total},
        ]
        
        return (
            <React.Fragment>
                {view === "sale" &&
                    <div>
                        <FormSale 
                            {...this.state} 
                            {...this.props} 
                            fromResa
                            handleSelect={this.handleSelect}
                            createAddFormP={this.state.form}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleClose={this.props.handleClose}
                            handleAddProd={this.handleAddProd} // impossible de rajouter des produits non dispo dans l'installation
                        />
                    </div>
                }
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "sale"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider" 
                    disabledSubmit={this.props.STATE.sales.fetching}
                >
                    <TableLayout>
                        <TableBody>
                            <ConfirmFormTemplate
                                transfer={this.state.sale}
                                client={this.state.client}
                                fieldList={fieldList}
                                sale
                            />
                        {/* {fieldList.map( field => {
                            if(this.state.client[field.name]){
                                return (
                                    <TableRow>
                                        <TableCell>{field.label}</TableCell>
                                        <TableCell colSpan={3}>{field.display}</TableCell>
                                    </TableRow>
                                )
                            } else if(this.state.sale[field.name]){
                                if (field.name === "products"){
                                    return this.state.sale.products.map((prod, index)=>(
                                        <TableRow>
                                            <TableCell>{prod.display.label}</TableCell>
                                            <TableCell>{prod.quantity}x{prod.price} {prod.price_U_real !== parseFloat(prod.price) && <i className="linethrough">{prod.price_U_real}</i>}</TableCell>
                                            
                                            <TableCell><b>{ prod.priceTotal }</b></TableCell>
                                        </TableRow>
                                    ))
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell colSpan={3}>{field.display}</TableCell>
                                        </TableRow>
                                    )
                                }
                            } 
                        }) }                             */}
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default FormTransfreInstallToSale;